import { useListContext, useTranslate } from "ra-core";
import { useIsMobile } from "@/hooks/use-mobile";

import {
  ListCardsSkeleton,
  ListEmptyState,
  ListErrorState,
  ListRowsSkeleton,
} from "../design/ListStates";
import { Task } from "./Task";
import { isDone, isRecentlyDone } from "./tasksPredicate";

export const TasksIterator = ({
  showContact,
  className,
}: {
  showContact?: boolean;
  className?: string;
}) => {
  const isMobile = useIsMobile();
  const translate = useTranslate();
  const { data, error, isPending, refetch } = useListContext();

  if (isPending) {
    return isMobile ? (
      <ListCardsSkeleton rows={3} />
    ) : (
      <ListRowsSkeleton rows={3} columns={2} />
    );
  }

  if (error) {
    return (
      <ListErrorState
        message={translate("crm.common.list_error")}
        onRetry={() => refetch()}
      />
    );
  }

  // A genuinely empty resource gets the short empty message; a group that
  // only lost its tasks to the done-filter below (e.g. a due-date bucket in
  // TasksListByDueDate whose tasks were all just completed) stays silent, as
  // before, so it doesn't show a stray "no tasks" message under every title.
  if (data.length === 0) {
    return <ListEmptyState title={translate("resources.tasks.empty")} />;
  }

  // Keep only tasks that are not done or done less than 5 minutes ago
  const tasks = data.filter((task) => !isDone(task) || isRecentlyDone(task));
  if (tasks.length === 0) return null;

  return (
    <div className={`space-y-4 md:space-y-2 ${className || ""}`}>
      {tasks.map((task) => (
        <Task task={task} showContact={showContact} key={task.id} />
      ))}
    </div>
  );
};
